<template>
    <div class="home">
        <Header/>
        <div class="content">
            <h2 class="create-api-text">
                Create New API
            </h2>
            <h4 class="api-endpoint-url">
                API Endpoint URL
            </h4>
            <div class="api-url">
                <span class="url-start-from">{{ this.baseUrl + this.randomUrlPart }}</span>
                <input class="url-ends-input" type="text" placeholder="enter-you-url-part-here" v-model="userUrl" :disabled="!canCreate">
            </div>

            <div class="checkbox-container">
                <input type="checkbox" id="checkbox-add-random" class="checkbox-add-random styled-checkbox" v-model="checkboxRandom" :disabled="!canCreate">
                <label for="checkbox-add-random" class="checkbox-label">
                    Add Random Prefix
                </label>
            </div>

            <h4 class="api-endpoint-url">
                Visibility
            </h4>
            <div class="visibility-radio-container">
                <div class="format-selector">
                    <label class="format-option" style="min-width: 80px;">
                        <input type="radio" name="visibility-selector" value="public" v-model="visibility" checked :disabled="!canCreate">
                        <span class="radio-circle"></span>
                        <span class="format-label">Public</span>
                    </label>
<!--                    <label class="format-option">-->
<!--                        <input type="radio" name="visibility-selector" value="private" v-model="visibility" @click="showAlert" disabled>-->
<!--                        <span class="radio-circle"></span>-->
<!--                        <span class="format-label">Private</span>-->
<!--                    </label>-->
                </div>
            </div>
            <h4 class="api-endpoint-url">
                Type
            </h4>
            <div class="type-radio-container">
                <div class="format-selector">
                    <label class="format-option" style="min-width: 80px;">
                        <input type="radio" name="type-selector" value="static" v-model="type" checked :disabled="!canCreate">
                        <span class="radio-circle"></span>
                        <span class="format-label">Static</span>
                    </label>

<!--                    <label class="format-option">-->
<!--                        <input type="radio" name="type-selector" value="dynamic" @click="showAlert" v-model="type" disabled>-->
<!--                        <span class="radio-circle"></span>-->
<!--                        <span class="format-label">Dynamic</span>-->
<!--                    </label>-->
                </div>
            </div>
            <h4 class="api-endpoint-url">
                Response Format
            </h4>
            <div class="format-radio-container">
                <div class="format-selector">

                    <label class="format-option" style="min-width: 80px;">
                        <input type="radio" name="format-selector" value="json" v-model="responseFormat" :disabled="!canCreate">
                        <span class="radio-circle"></span>
                        <span class="format-label">JSON</span>
                    </label>

                    <label class="format-option">
                        <input type="radio" name="format-selector" value="html" v-model="responseFormat" :disabled="!canCreate">
                        <span class="radio-circle"></span>
                        <span class="format-label">HTML</span>
                    </label>

                    <label class="format-option" style="min-width: 110px;">
                        <input type="radio" name="format-selector" value="plain" v-model="responseFormat" :disabled="!canCreate">
                        <span class="radio-circle"></span>
                        <span class="format-label">Plain Text</span>
                    </label>

                </div>
            </div>

            <h4 class="api-endpoint-url">
                Write Your Data
            </h4>
            <div class="your-data">
                <textarea rows="10" class="your-data-textarea" v-model="responseData" :disabled="!canCreate"></textarea>
            </div>

            <button :class="{
              'create-button_idle': canCreate,
              'create-button_blocked': !canCreate,
              'create-button_success': isSuccess,
              'create-button_error': isError
            }"
                    class="create-button"
                    @click="() => canCreate && submitData()">
              {{ buttonText }}
            </button>

            <h4 v-if="usage" class="api-endpoint-url">
                Open in Terminal via Curl
            </h4>

            <div v-if="usage" class="usage-block" @click="copyToClipboard">
                curl -X GET {{ usage }} --output -
            </div>

            <h4 v-if="usage" class="api-endpoint-url">
                Open in Web Browser
            </h4>

            <div v-if="usage" class="usage-block">
                <a :href="usage" target="_blank" style="color: white">{{ usage }}</a>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import Header from '@/components/Header.vue';
import { usePostApi } from '@/composables/usePostApi';
import { isProduction } from '@/composables/env';

const { error, sendPost } = usePostApi();


/**
 * Generates a random string of 16 characters from English letters and numbers, excluding the number 4.
 * @returns A string of 16 random characters.
 */
function generate16CharsExclude4(): string {
    // Define all allowed characters (English letters and numbers, excluding 4)
    // noinspection SpellCheckingInspection
    const allowedChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123567890123567890123567890';
    let result = '';

    // Generate 16 characters
    for (let i = 0; i < 16; i++) {
        // Get a random index from the allowedChars string
        const randomIndex = Math.floor(Math.random() * allowedChars.length);
        // Append the character at the random index to the result
        result += allowedChars.charAt(randomIndex);
    }

    return result;
}

/**
 * Generates a random string of 18 characters from lowercase letters and numbers.
 * This satisfies the pattern ^[a-z0-9]{18}$
 * @returns A string of 18 random characters.
 */
function generateUnauthorizedOwner(): string {
    // Define allowed characters (lowercase letters and numbers)
    const allowedChars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';

    // Generate 18 characters
    for (let i = 0; i < 18; i++) {
        const randomIndex = Math.floor(Math.random() * allowedChars.length);
        result += allowedChars.charAt(randomIndex);
    }

    return result;
}

function initializeUnauthorizedOwner(): string {
    let unauthorizedOwner = localStorage.getItem('unauthorized_owner');

    // Check if unauthorized_owner exists and matches the required pattern
    const ownerPattern = /^[a-z0-9]{18}$/;
    if (!unauthorizedOwner || !ownerPattern.test(unauthorizedOwner)) {
        // Generate a new token
        unauthorizedOwner = generateUnauthorizedOwner();
        // Store in localStorage
        localStorage.setItem('unauthorized_owner', unauthorizedOwner);
    }

    return unauthorizedOwner;
}

@Options({
    components: {
        Header,
    },
    watch: {
        checkboxRandom(newValue: boolean) {
            if (newValue) {
                this.randomUrlPart = generate16CharsExclude4() + '/';
            } else {
                this.randomUrlPart = '';
            }
        }
    }
})


export default class HomeView extends Vue {
    baseUrl = `${window.location.origin}/api/`;
    randomUrlPart = generate16CharsExclude4() + '/';
    visibility = 'public';
    type = 'static';
    responseFormat = 'json';
    userUrl = isProduction ? '' : `bbb`;
    responseData = isProduction ?  '' : `{"a": "b"}`;

    canCreate = true;
    isSuccess = false;
    isError = false;
    buttonText = 'Create';
    usage = '';
    copied = false;

    checkboxRandom = true;

    unauthorizedOwner = '';

    created() {
        this.unauthorizedOwner = initializeUnauthorizedOwner();
    }


    showAlert = () => {
        alert('Work in Progress...');
    }

    submitData = async () => {
        this.canCreate = false;
        this.buttonText = "Request in Progress. Stand by...";
        const responseData = await sendPost({
            url: this.baseUrl + this.randomUrlPart + this.userUrl,
            visibility: this.visibility,
            type: this.type,
            response_format: this.responseFormat,
            response_data: this.responseData,
            unauthorized_owner: this.unauthorizedOwner,
        });
        if (error.value) {
            this.buttonText = error?.value ?? '';
            this.isError = true;
        } else {
            this.buttonText = "Successfully Created!";
            this.isSuccess = true;
            this.usage = responseData?.data?.url ?? '';
        }
    };

    copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(this.usage)
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 2000)
            alert('Successfully Copied!');
        } catch (err) {
            console.error('Failed to copy text: ', err)
        }
    }
}
</script>

<style lang="stylus" scoped>
.home
    height fit-content
    min-height 100vh
    background-color #e7e7e7

.content
    min-width 1200px
    max-width 1200px
    margin-top 24px
    margin-left auto
    margin-right auto
    background-color white
    box-shadow rgba(99, 99, 99, 0.2) 0px 2px 8px 0px
    border-radius 10px
    display flex
    flex-direction column
    padding-left 30px
    padding-right 30px
    padding-top 20px
    padding-bottom 25px

content *
    display flex

.create-api-text
    font-weight bold
    text-align left
    margin 0

.api-endpoint-url
    margin 0
    margin-top 28px

.api-url
    display flex
    margin-top 12px

.url-start-from
    background-color #e9e9e9
    padding-left 14px
    padding-top 12px
    padding-bottom 12px
    padding-right 8px
    font-weight 600
    border-top-left-radius 10px
    border-bottom-left-radius 10px
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    border-left 0.2px solid #cccccc
    border-top 0.2px solid #cccccc
    border-bottom 0.2px solid #cccccc
    min-width fit-content
    width fit-content

.url-ends-input
    border 0.2px solid #cccccc
    font-weight 600
    border-top-right-radius 10px
    border-bottom-right-radius 10px
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    width 100%
    padding-left 8px
    font-size: 18px;

.url-ends-input:focus
    outline none
    font-size: 18px;
    font-weight 600
    border-right 1px solid #666
    border-top 1px solid #666
    border-bottom 1px solid #666

.visibility-radio-container
    //

// GPT Generated Radio Buttons Style
.format-selector
    display flex
    align-items center
    gap 16px
    font-family -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif

.format-option
    display flex
    align-items center
    gap 8px
    cursor pointer

    input[type="radio"]
        display none

    input[type="radio"]:checked + .radio-circle
        //border-color #3b82f6
        border-color #4f46e5

        &:after
            transform translate(-50%, -50%) scale(1)

    input[type="radio"]:checked ~ .format-label
        color #111827
        font-weight 600

.radio-circle
    display block
    width 20px
    height 20px
    border 2px solid #d1d5db
    border-radius 50%
    position relative

    &:after
        content ""
        display block
        width 10px
        height 10px
        //background-color #3b82f6
        background-color #4f46e5
        border-radius 50%
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%) scale(0)
        transition transform 0.15s ease-in-out

.format-label
    font-size 16px
    color #4b5563
    font-weight 500
    user-select none

.visibility-radio-container
    margin-top 14px

.type-radio-container
    margin-top 14px

.format-radio-container
    margin-top 14px

.your-data
    margin-top 14px
    width 100%

.your-data-textarea
    min-width 98%
    max-width 98%
    min-height 156px
    width 99%
    border-radius 10px
    border none
    outline 1px solid #999999
    box-shadow rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    padding 10px

.create-button
    color white
    font-weight bold
    border none
    border-radius 10px
    align-self right
    margin-left auto
    padding-top 10px
    padding-bottom 10px
    padding-left 18px
    padding-right 18px
    margin-top 12px
    font-size 16px
    box-shadow rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    margin-right 3px

.create-button_idle
    background-color #4f46e5

.create-button_idle:hover
    background-color #342bde

.create-button_blocked
    background-color #444444

.create-button_success
    background-color #198755 !important

.create-button_error
    background-color #dc3546

.usage-block
    background-color black
    color white
    font-weight bold
    padding: 10px;
    padding-left: 15px;
    margin-top: 10px;

.checkbox-container
    user-select none
    margin-top 12px
    display flex
    align-items center
    gap 8px

.checkbox-add-random
    width 20px
    height 20px

.checkbox-add-random:checked
    accent-color #4f46e5

.checkbox-add-random:disabled
    accent-color #444 !important

.checkbox-add-random:checked + label
    font-weight 600

.checkbox-container label
    margin-bottom -2px


input:disabled:checked + span
    border-color #444 !important

input:disabled:checked + span::after
    background-color #444 !important
    color #444 !important
</style>
